import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="phone-input"
export default class extends Controller {
  static targets = ["code", "number", "hidden"];

  connect() {
    this.updateHiddenField();
  }

  updateHiddenField() {
    const code = this.codeTarget.value;
    let number = this.numberTarget.value.trim();

    // If the input is empty, clear the hidden field so it's ignored by the backend
    if (number === "") {
      this.hiddenTarget.value = "";
      return;
    }

    // Smart Catch: If the user selects a past customer from the datalist
    // or pastes a number that already has a '+', use it exactly as is.
    if (number.startsWith("+")) {
      this.hiddenTarget.value = number;
      return;
    }

    // Standardize: Remove any leading zeros (common in local dialing)
    // before appending to the country code.
    const cleanNumber = number.replace(/^0+/, "");

    // Stitch them together and push to the hidden field
    this.hiddenTarget.value = `${code}${cleanNumber}`;
  }
}
